import { useEffect, useState } from 'react';
import { TargetType } from '../../../shared/types/comment.ts';
import { ModalDialog } from '../../components/modalDialog.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    target: string;
    targetType: TargetType;
    displayName: string;
    initialText?: string;
    onSubmited: () => void;
    onClose: () => void;
}

export function CommentDialog({
    target,
    targetType,
    displayName,
    initialText,
    onSubmited,
    onClose,
}: Props) {

    const [input, setInput] = useState('');

    const setComment = trpc.comments.set.useMutation();


    useEffect(() => {
        setInput(initialText ?? '');
    }, [initialText]);


    const handleSubmit = async () => {
        await setComment.mutateAsync({ target, targetType, text: input });
        onSubmited();
        onClose();
    }


    const targetTypeLabel = targetType === 'equipment' ? 'equipment' : 'part number';
    return (
        <ModalDialog
            isOpen={true}
            frameClassName='modal-frame--fixed_width'
            contentClassName='modal-content--tablet'
            onCancel={onClose}
        >
            <div>Comment for {targetTypeLabel}: {displayName}</div>
            <textarea
                className='product-comment'
                style={{ marginTop: '8px', width: '100%' }}
                value={input}
                rows={3}
                onChange={(e) => setInput(e.target.value)} />

            <div className='dialog--button-bar'>
                <button
                    className='button--large'
                    onClick={handleSubmit}
                    children='Submit'
                />
            </div>
        </ModalDialog>
    )
}
